import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useCommentUtils() {
    var _a = React.useState(), commentElement = _a[0], setCommentElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || commentElement)
            return;
        var loadedCommentElement = client.getCommentElement();
        setCommentElement(loadedCommentElement);
    }, [client, setCommentElement, commentElement]);
    return commentElement;
}
export function useCommentAnnotations(documentId, location) {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the inputs
    var inputs = React.useMemo(function () {
        return { documentId: documentId, location: location };
    }, [documentId, JSON.stringify(location)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getAllCommentAnnotations(inputs.documentId, inputs.location)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations, inputs]);
    return data;
}
export function useUnreadCommentCountByAnnotationId(annotationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedAnnotationId = React.useMemo(function () { return annotationId; }, [annotationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentCountByAnnotationId(memoizedAnnotationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId, memoizedAnnotationId]);
    return data;
}
export function useUnreadCommentAnnotationCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentAnnotationCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument]);
    return data;
}
export function useUnreadCommentCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument]);
    return data;
}
export function useUnreadCommentCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedLocationId = React.useMemo(function () { return locationId; }, [locationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentCountByLocationId(memoizedLocationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId, memoizedLocationId]);
    return data;
}
export function useUnreadCommentAnnotationCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedLocationId = React.useMemo(function () { return locationId; }, [locationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentAnnotationCountByLocationId(memoizedLocationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId, memoizedLocationId]);
    return data;
}
export function useCommentModeState() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange))
            return;
        var subscription = commentElement.onCommentModeChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange]);
    return data;
}
function useIsUserGlobalContact() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.isUserGlobalContact))
            return;
        var subscription = commentElement.isUserGlobalContact().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.isUserGlobalContact]);
    return data;
}
/**
 * @legacy Use `useCommentEventCallback('addCommentAnnotation')` event hook instead.
 */
export function useCommentAddHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd))
            return;
        var subscription = commentElement.onCommentAdd().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd]);
    return data;
}
/**
 * @legacy Use `useCommentEventCallback` event hook instead.
 */
export function useCommentUpdateHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate))
            return;
        var subscription = commentElement.onCommentUpdate().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate]);
    return data;
}
export function useCommentDialogSidebarClickHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick))
            return;
        var subscription = commentElement.onSidebarButtonOnCommentDialogClick().subscribe(function (res) {
            setData(res === undefined ? new Date().getTime() : res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick]);
    return data;
}
export function useCommentSelectionChangeHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange))
            return;
        var subscription = commentElement.onCommentSelectionChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange]);
    return data;
}
export function useCommentCopyLinkHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCopyLink))
            return;
        var subscription = commentElement.onCopyLink().subscribe(function (res) {
            if (res) {
                setData({ link: res });
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCopyLink]);
    return data;
}
export function useCommentAnnotationById(config) {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedConfig = React.useMemo(function () { return config; }, [config.annotationId, config.documentId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationById))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotationById(memoizedConfig)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationById, memoizedConfig]);
    return data;
}
export function useCommentSidebarActionButtonClick() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarActionButtonClick))
            return;
        var subscription = commentElement.onCommentSidebarActionButtonClick().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarActionButtonClick]);
    return data;
}
export function useCommentSidebarInit() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarInit))
            return;
        var subscription = commentElement.onCommentSidebarInit().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarInit]);
    return data;
}
export function useCommentSidebarData() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarData))
            return;
        var subscription = commentElement.onCommentSidebarData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarData]);
    return data;
}
export function useSetContextProvider() {
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var commentUtils = useCommentUtils();
    React.useEffect(function () {
        if ((commentUtils === null || commentUtils === void 0 ? void 0 : commentUtils.setContextProvider) && data) {
            commentUtils.setContextProvider(data);
        }
    }, [commentUtils === null || commentUtils === void 0 ? void 0 : commentUtils.setContextProvider, data]);
    // Memoize the setContextProvider callback
    var setContextProviderCallback = React.useCallback(function (provider) {
        // Wrap in arrow function to prevent React from treating provider as a functional update
        setData(function () { return provider; });
    }, []); // Empty dependency array since it only uses setState which is stable
    return {
        setContextProvider: setContextProviderCallback
    };
}
